import { NgModule } from '@angular/core';
import { VoiceProvider, MessagingProvider, TelephonyProvider, InsightProvider } from './telephony.provider';
import { TwilioTelephonyProvider } from './twilio/twilio.telephony.provider';
import { IbexTelephonyProvider } from './ibex/ibex.telephony.provider';
import { TwilioMessagingProvider } from './twilio/twilio.messaging.provider';
import { TwilioVoiceProvider } from './twilio/twilio.voice.provider';
import { AuthenticationService } from '@app/core';
import { IbexVoiceProvider } from './ibex/ibex.voice.provider';
import { IbexMessagingProvider } from './ibex/ibex.messaging.provider';
import { TwilioInsightProvider } from './twilio/twilio.insight.provider';
import { IbexInsightProvider } from './ibex/ibex.insight.provider';
import { DelegatingTelephonyProvider } from './delegating.telephony.provider';

const TeleCommunicationFactory = (
  twilio: TwilioTelephonyProvider,
  ibex: IbexTelephonyProvider,
  auth: AuthenticationService
) => {
  let clientProvider = auth.authData?.ClientInfo?.Provider?.TelephoneProvider || 'none';
  if (clientProvider.toLowerCase() == 'ibex') {
    return ibex;
  } else if (clientProvider.toLowerCase() === 'twilio') {
    return twilio;
  }
  return twilio;
};

const VoiceProviderFactory = (twilio: TwilioVoiceProvider, ibex: IbexVoiceProvider, auth: AuthenticationService) => {
  const clientProvider = auth.authData?.ClientInfo?.Provider?.TelephoneProvider || 'none';
  if (clientProvider.toLowerCase() == 'ibex') {
    return ibex;
  } else if (clientProvider.toLowerCase() === 'twilio') {
    return twilio;
  }
  return twilio;
};



@NgModule({
  providers: [
    TwilioMessagingProvider,
    IbexMessagingProvider,

    TwilioInsightProvider,
    IbexInsightProvider,
    //TwilioVoiceProvider,
    //IbexVoiceProvider,
    IbexTelephonyProvider,
    TwilioTelephonyProvider,
    {
      provide: VoiceProvider,
      useFactory: VoiceProviderFactory,
      deps: [TwilioVoiceProvider, IbexVoiceProvider, AuthenticationService],
      multi: false,
    },
    {
      provide: MessagingProvider,
      useFactory: MessagingProvider,
      deps: [TwilioMessagingProvider, IbexMessagingProvider, AuthenticationService],
      multi: false,
    },
    {
      provide: InsightProvider,
      useFactory: InsightProvider,
      deps: [TwilioInsightProvider, IbexInsightProvider, AuthenticationService],
      multi: false,
    },
    {
      provide: TelephonyProvider,
      useClass: DelegatingTelephonyProvider,
    },
  ],
})
export class TelephonyProviderModule {}
